import { Avatar } from "@mantine/core";
import { useState } from "react";

const TOKEN = import.meta.env.VITE_LOGODEV_TOKEN ?? "";

interface LogoImgProps {
  domain: string;
  size?: number;
  alt?: string;
  style?: React.CSSProperties;
}

export function LogoImg({ domain, size = 24, alt, style }: LogoImgProps) {
  const [loadFailed, setLoadFailed] = useState(false);

  if (loadFailed || !TOKEN) {
    return (
      <Avatar
        size={size}
        radius={Math.max(size / 6, 3)}
        color="gray"
        style={style}
      >
        {(alt ?? domain).charAt(0).toUpperCase() || "?"}
      </Avatar>
    );
  }

  return (
    <img
      src={`https://img.logo.dev/${encodeURIComponent(domain)}?token=${TOKEN}&size=${size}&format=png`}
      alt={alt ?? domain}
      width={size}
      height={size}
      style={{ borderRadius: Math.max(size / 6, 3), ...style }}
      onError={() => setLoadFailed(true)}
      loading="lazy"
    />
  );
}
